import {
  MultipleChoice,
  MultipleChoiceGroup,
  Template,
} from '@ulysses-inc/harami_api_client'
import { Dispatch, SetStateAction } from 'react'
import { isDefined } from 'src/util/isDefined'
import { TMultipleChoicesState } from '../../MultipleChoiceDrawer'

type MultipleChoicesRecord = TMultipleChoicesState[0]
type SetMultipleChoices = Dispatch<SetStateAction<MultipleChoicesRecord>>

/**
 * 選択肢ボタン行コンポーネントの共通Props型
 */
export type MultipleChoiceButtonsRowProps = {
  onClose: () => void
  multipleChoicesState: TMultipleChoicesState
  multipleChoiceGroupForUpdate: MultipleChoiceGroup | undefined
  relatedTemplates: Template[] | undefined
  isFetchingRelatedTemplates: boolean
  isErrorRelatedTemplates: boolean
}

export const createMultipleChoiceButtonsCommon = (
  multipleChoices: MultipleChoicesRecord,
  setMultipleChoices: SetMultipleChoices,
  onClose: () => void,
) => {
  /**
   * ドロワーを閉じて状態をリセット
   */
  const handleCloseDrawer = async () => {
    // modalとdrawerが同時に閉じるとスクロールできなくなるので、遅延させる
    await new Promise(resolve => setTimeout(resolve, 100))
    onClose()
    setMultipleChoices({})
  }

  /**
   * 空でない選択肢のみをフィルタリング
   */
  const getFilteredMultipleChoices = (): MultipleChoice[] => {
    return Object.values(multipleChoices)
      .filter(isDefined)
      .filter(multipleChoice => multipleChoice.response !== '')
  }

  return {
    handleCloseDrawer,
    getFilteredMultipleChoices,
  }
}
